<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    title="修改转移码"
  >
    <div class="content" style="position: relative" v-if="data">
      <loading :loading="loading" style="z-index: 11"></loading>
      <div class="row">
        <div class="name">转入的域名：</div>
        <div class="label">{{ data.domainName }}</div>
      </div>
      <div class="row">
        <div class="name">域名转移码：</div>
        <div class="label">
          <Input
            v-model.trim="code"
            placeholder="请填写"
            style="width: 200px"
          />
        </div>
      </div>
    </div>
    <div class="foot">
      <Button @click="onConfirm" :loading="loading">确认</Button>
      <Button @click="onCancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import { transferIntoEdit } from "api/domain.js";
import loading from "components/loading.vue";

export default {
  name: "changeTransferCodeModal",
  components: {
    loading,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      code: "",
    };
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    async onConfirm() {
      try {
        this.loading = true;
        const data = {
          id: this.data.id,
          transferCode: this.code,
        };
        const { code } = await transferIntoEdit(data);
        if (code === 200) {
          this.$Message.success("修改成功！");
          this.$emit("success");
          this.cancel();
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    onCancel() {
      this.visibility = false;
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.row {
  display: flex;
  line-height: 40px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}
</style>
